import { render, staticRenderFns } from "./AddTaskSpaceModal.vue?vue&type=template&id=115c0047&"
import script from "./AddTaskSpaceModal.vue?vue&type=script&lang=js&"
export * from "./AddTaskSpaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports